import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { dismissToast } from '@rsos/components/capstone/base/Toast';
import {
  ACCEPTED,
  TIMEOUT,
  DISPATCH_REQUESTED,
} from '@rsos/constants/alertStatuses';
import {
  RESPONSIBLE_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE,
  NOTIFIED_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE,
  NOTIFIED_AGENCY,
} from '@rsos/constants/alertsRoutingConstants';
import { notifyMassDisaster } from '@rsos/utils/toastUtils';
import usePrevious from '@rsos/utils/usePrevious';
import { handleToastIncidentStatusChange } from '../components/JurisdictionView/helpers';

/**
 * Manage Train Incident Alert Toasts Notifications
 */
const useTrainIncidentToastsNotifications = () => {
  const { removedAlerts } = useSelector(state => state.incidents);
  const { trainAlerts } = useSelector(state => state.incidents);
  const { profile } = useSelector(state => state.sinatra.user);
  const prevTrainAlerts = usePrevious(trainAlerts) || {};
  const [trainIncidentToasts, setTrainIncidentToasts] = useState({});
  const stateRef = useRef();
  stateRef.current = trainIncidentToasts;

  useEffect(() => {
    if (JSON.stringify(trainAlerts) !== '{}') {
      Object.values(trainAlerts).forEach(a => {
        if (
          !trainIncidentToasts[a.alert_id]?.toastId &&
          !trainIncidentToasts[a.alert_id]?.closed &&
          a.status.name === DISPATCH_REQUESTED
        ) {
          let message;
          if (a.associated_role_type === NOTIFIED_AGENCY) {
            message =
              NOTIFIED_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE +
              ' ' +
              a.covering_psap?.name;
          } else {
            message = RESPONSIBLE_AGENCY_TRAIN_INCIDENT_TOAST_MESSAGE;
          }
          const toastParams = {
            message: message,
            customIcon: AttentionTriangleIcon,
            options: {
              onClose: () => {
                setTrainIncidentToasts({
                  ...stateRef.current,
                  [a.alert_id]: { toastId: null, closed: true },
                });
              },
            },
          };
          const id = notifyMassDisaster(toastParams);
          return setTrainIncidentToasts({
            ...trainIncidentToasts,
            [a.alert_id]: { toastId: id },
          });
        } else if (
          a.associated_role_type !== NOTIFIED_AGENCY &&
          a.status.name === ACCEPTED &&
          prevTrainAlerts[a.alert_id]?.status.name === DISPATCH_REQUESTED
        ) {
          return handleToastIncidentStatusChange(
            ACCEPTED,
            a,
            trainIncidentToasts,
            profile,
          );
        } else if (
          a.status.name === TIMEOUT &&
          prevTrainAlerts[a.alert_id]?.status.name !== TIMEOUT
        ) {
          if (trainIncidentToasts[a.alert_id]?.toastId) {
            return handleToastIncidentStatusChange(
              TIMEOUT,
              a,
              trainIncidentToasts,
            );
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trainAlerts]);

  useEffect(() => {
    if (removedAlerts.length && JSON.stringify(trainIncidentToasts) !== '{}') {
      Object.keys(trainIncidentToasts).forEach(a => {
        if (
          removedAlerts.find(element => element === a) &&
          trainIncidentToasts[a]?.toastId
        ) {
          dismissToast(trainIncidentToasts[a].toastId);
          setTrainIncidentToasts({
            ...trainIncidentToasts,
            [a]: { toastId: null },
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removedAlerts]);
};

export default useTrainIncidentToastsNotifications;
